export default __webpack_public_path__ + "static/BrushedMaroon-25d4b4fff441a7af6e58020c9a758966.svg";